<template lang="pug">
    #TenantCenter.main-page-tenant-center.TenantCenter-background.page-noScroll.pb-0.position-relative
        loadingOverlay(v-if='loading' message='Loading . . .' :zIndex='999' attach)
        div(v-if='!loading')
            v-card.deal-tab-card.rounded-card.d-flex.justify-center(flat color='transparent')
                v-row
                    v-col(cols='12')
                        v-data-table.pl-4.pr-4.mt-0.can-select-table.can-select-text(:id="'all'" :headers="tenantCostRankHeaders", :items="tenantCostRankList", :loading="cost_list_loading" :header-props="{sortIcon: 'mdi mdi-arrow-up'}",)
                            template( v-slot:item.tenant="{ item }" )
                                .ellipsis
                                    span.ellipsis(:title='item.tenant') {{ item.tenant }}
                    v-col(cols='12' v-for="(monthTb, monthKey) in monthlyCostList"  :key='monthKey')
                        h4 {{monthKey}}
                        v-data-table.pl-4.pr-4.mt-0.can-select-table.can-select-text(:headers="monthlyCostHeaders" :items="monthTb" :loading="month_list_loading" :header-props="{id:'value',sortIcon: 'mdi mdi-arrow-up'}" )
                            template( v-slot:item.tenant="{ item }" )
                                .ellipsis
                                    span.ellipsis(:title='item.tenant') {{ item.tenant }}
    
        v-dialog(v-model='addTenantDialog' width='480' content-class='statusDialog' v-if='addTenantDialog' persistent)
            add-tenant-dialog(@emitAddTenatDialog='onEmitAddTenantDialog' @emitNormalAddTenant='onEmitNormalAddTenant')
        v-dialog(v-model='addSuperUserDialog' width='480' content-class='statusDialog' v-if='addSuperUserDialog' persistent)
            add-superuser-dialog(@emitAddSuperUserDialog='onEmitAddSuperUserDialog' :tenantListItems='tenantListItems')
        v-dialog(v-model='successDialog' width='360' content-class='statusDialog')
            success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
        v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' persistent)
            message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message' )
        v-dialog(v-model='errorDialog' width='360'  content-class='statusDialog')
            error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
</template>
<script>
    import i18n from '/common/plugins/vue-i18n.js';
    import TenantCenterService from "@/services/TenantCenterService";
    import addTenantDialog from "@/components/TenantCenter/addTenant";
    import addSuperuserDialog from "@/components/TenantCenter/addSuperUser";
    import successDialog from "@/components/Dialog/successDialog";
    import messageDialog from '@/components/Dialog/messageDialog';
    export default {
        name: "TenantCenter-Usage-Sumarry",
        components: {
            addTenantDialog,
            addSuperuserDialog,
            successDialog,
            messageDialog,
        },
        data() {
            return{
                loading:false,
                cost_list_loading:false,
                month_list_loading:false,
                addTenantDialog: false,
                addSuperUserDialog: false,
                errorMessage:"",
                message:"",
                messageDialog:false,
                successDialog:false,
                errorDialog:false,
                inProcessing:false,
                showRefreshBtn:false,
                created_tenant: "",
                tenantCostRankList: [],
                tenantCostRankHeaders: [
                    {
                    text: 'Tenant',
                    align: 'left',
                    sortable: true,
                    value: 'tenant',
                    class: "white lighten-5",
                    },
                    {
                        text: i18n.t('TENANTCENTER_TENANT_LIST.DESCRIPTION'),
                        align: 'left',
                        sortable: false,
                        value: 'description',
                        class: "white lighten-5",
                    },
                    {
                        text: i18n.t('GPT_ANALYSIS.TABLE_HEADER_10'),
                        align: 'left',
                        sortable: false,
                        value: 'subscription_end_date',
                        class: "white lighten-5",
                    },
                    {
                    text: i18n.t('TENANTCENTER_SUMMARY.RANK_TABLE_HEADER_1'),
                    align: 'left',
                    sortable: true,
                    value: 'storage',
                    class: "white lighten-5",
                    },
                    {
                    text: i18n.t('TENANTCENTER_SUMMARY.RANK_TABLE_HEADER_4'),
                    align: 'left',
                    sortable: true,
                    value: 'image_used',
                    class: "white lighten-5",
                    },
                    {
                    text: i18n.t('TENANTCENTER_SUMMARY.RANK_TABLE_HEADER_5'),
                    align: 'left',
                    sortable: true,
                    value: 'image_storage',
                    class: "white lighten-5",
                    },
                    {
                    text: i18n.t('TENANTCENTER_SUMMARY.RANK_TABLE_HEADER_2'),
                    align: 'left',
                    sortable: true,
                    value: 'idp_used',
                    class: "white lighten-5",
                    },
                    {
                    text: i18n.t('TENANTCENTER_SUMMARY.RANK_TABLE_HEADER_3'),
                    align: 'left',
                    sortable: true,
                    value: 'idp_page',
                    class: "white lighten-5",
                    },
                    {
                    text: i18n.t('TENANTCENTER_SUMMARY.RANK_TABLE_HEADER_6'),
                    align: 'left',
                    sortable: true,
                    value: 'remain_amount',
                    class: "white lighten-5",
                    },
                    {
                    text: i18n.t('TENANTCENTER_SUMMARY.RANK_TABLE_HEADER_7'),
                    align: 'left',
                    sortable: true,
                    value: 'purchase_amount',
                    class: "white lighten-5",
                    }
                ],
                byte:1073741824,
                monthlyCostHeaders: [
                    {
                    text: 'Tenant',
                    align: 'left',
                    sortable: true,
                    value: 'tenant',
                    class: "white lighten-5",
                    },
                    {
                    text: 'Description',
                    align: 'left',
                    sortable: true,
                    value: 'description',
                    class: "white lighten-5",
                    },
                    {
                    text: 'Subscription End Date',
                    align: 'left',
                    sortable: true,
                    value: 'subscription_end_date',
                    class: "white lighten-5",
                    },
                    {
                    text: 'Total Cost (USD)',
                    align: 'left',
                    sortable: true,
                    value: 'total_cost',
                    class: "white lighten-5",
                    },
                    {
                    text: 'Token Used',
                    align: 'left',
                    sortable: true,
                    value: 'token_used',
                    class: "white lighten-5",
                    },
                    {
                    text: 'Total Number of Message',
                    align: 'left',
                    sortable: true,
                    value: 'message_num',
                    class: "white lighten-5",
                    },
                    {
                    text: 'Num of Conversation',
                    align: 'left',
                    sortable: true,
                    value: 'conversation_num',
                    class: "white lighten-5",
                    },
                ],
                monthlyCostList: [],

            }
        },
        mounted() {
            // let hash = window.location.hash
            // if(hash.startsWith('#month-') || hash.startsWith('#all')){
            //     let el = document.querySelector(hash)
            //     if (el) el.scrollIntoView({ behavior: 'auto' })
            // }
        },
        created() {
            
            this.tenant_cost_rank()
            this.tenant_monthly_cost()
            
        },
        methods: {
            async tenant_cost_rank(){
                this.cost_list_loading = true;
                await TenantCenterService.tenantCostRank().then(response => {
                    this.tenantCostRankList = response.data;
                    this.tenantCostRankList.forEach(item => {
                        item.storage = (item.storage/this.byte).toFixed(2);
                        let remaing_cost = (item.purchase_amount - item.ai_cost).toFixed(2);
                        item['remain_amount'] = remaing_cost
                    })
                    console.log('rank data', response.data)
                    
                })
                this.cost_list_loading = false
            },
            async tenant_monthly_cost(){
                this.month_list_loading = true;
                await TenantCenterService.tenantMonthlyCost().then(response => {
                    console.log('55dddd', response.data)
                    this.monthlyCostList = response.data.reduce((acc, item) => {
                        item.total_cost = item.total_cost.toFixed(2);

                        let month = item.year_month;
                        if(!acc[month]){
                            acc[month] = [];
                        }
                        acc[month].push(item);
                        return acc;
                    },{})
                    
                    console.log('month month month', this.monthlyCostList)
                })

                this.month_list_loading = false;
            },
            toUserListPage(data) {
                this.$router.push(`/tenant_center/user_list/${data.name}`);
            },
            onEmitAddTenantDialog(val){
                if(val.close == true){
                    const storageKey = 'new_create_tenant';
                    window.localStorage.setItem(storageKey, val.tenant);
                    this.showRefreshBtn = true;
                    this.inProcessing = true;
                    this.addTenantDialog = false;
                }
                this.showMessageDialog(i18n.t('ADD_TENANT.ADD_TENANT_WAIT'));  
            },
            onEmitNormalAddTenant(){
                this.addTenantDialog = false;
            },
            onEmitAddSuperUserDialog(){
                this.addSuperUserDialog = false;
            },
            async onClicktoLoadData(data){
                await TenantCenterService.loadSeedData(data).then(response => {
                    if(response.data) this.showSuccessDialog();
                }).catch(response => {
                    this.showErrorDialog(response)
                })
            },
            showSuccessDialog() {
                this.successDialog = true;
            },
            async onEmitSuccessDialog() {
                this.successDialog = false;
            },
            showMessageDialog(message) {
				this.messageDialog = true;
				this.message = message;
			},
            async onEmitMessageDialog() {
                this.messageDialog = false;
            },
            showErrorDialog(message) {
                this.errorDialog = true;
                this.errorMessage = message;
            },
            onEmitErrorDialog() {
                this.errorMessage = false;
            },
        }
    }
</script>

<style lang="scss" scoped>
   .tab-item-bg{
        background-color: rgba(255, 255, 255, 0.7);
    }
</style>
